export default __webpack_public_path__ + "static/media/socket_io.aa27363b.svg";